import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { SinDatosParaMostrarComponent } from '@component/sin-datos-para-mostrar/sin-datos-para-mostrar.component';
import { ExpedienteDto } from '@models/expediente/expedienteDto.model';
import { NgxSpinnerModule } from 'ngx-spinner';

@Component({
  selector: 'app-list-expediente-simple',
  standalone: true,
  imports: [MatCardModule, MatButtonModule, CommonModule, NgxSpinnerModule, MatIconModule,MatTooltipModule,RouterModule,SinDatosParaMostrarComponent,MatDialogModule],
  templateUrl: './list-expediente-simple.component.html',
  styleUrl: './list-expediente-simple.component.css',
})
export class ListExpedienteSimpleComponent {

  @Input() expedientes!: ExpedienteDto[];

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnChanges() {
    this.cdr.detectChanges(); // fuerza actualización
  }
}


